import { useState, useCallback } from "react";
import TreeNode from "./TreeNode";
import classes from "./TreeSelect.module.css";

export default function TreeSelect({
  includedUsers,
  setIncludedUsers,
  excludeUsers,
  setExcludeUsers,
}) {
  // list of users for currently checked
  const [includedChecked, setIncludedChecked] = useState(new Set());
  const [excludeChecked, setExcludeChecked] = useState(new Set());

  const handleToggleCheck = useCallback((setChecked) => {
    return (node) => {
      setChecked((prev) => {
        const next = new Set(prev);
        if (next.has(node.user_id)) {
          next.delete(node.user_id);
        } else {
          next.add(node.user_id);
        }
        return next;
      });
    };
  }, []);

  const removeFromTree = (sourceList, checkedList) => {
    const valuesToRemove = new Set(checkedList.map((obj) => obj.user_id));
    const res = sourceList.filter((item) => !valuesToRemove.has(item.user_id));

    return res;
  };
  // Exclude selected: move checked items from access to exclude
  const handleExclude = () => {
    const checkedItemWithName = includedUsers.filter((item) =>
      excludeChecked.has(item.user_id)
    );

    setExcludeUsers((prev) =>
      [...prev, ...checkedItemWithName].sort((a, b) =>
        a.first_name.localeCompare(b.first_name)
      )
    );
    setIncludedUsers((prev) => removeFromTree(prev, checkedItemWithName));
    setIncludedChecked(new Set());
    setExcludeChecked(new Set());
  };

  const handleExcludeAll = () => {
    setExcludeUsers((prev) =>
      [...prev, ...includedUsers].sort((a, b) =>
        a.first_name.localeCompare(b.first_name)
      )
    );
    setIncludedUsers([]);
    setIncludedChecked(new Set());
    setExcludeChecked(new Set());
  };

  // Include selected: move checked users from exclude list to include list
  const handleInclude = () => {
    const checkedItemWithName = excludeUsers.filter((item) =>
      includedChecked.has(item.user_id)
    );
    setExcludeUsers((prev) => removeFromTree(prev, checkedItemWithName));
    setIncludedUsers((prev) =>
      [...prev, ...checkedItemWithName].sort((a, b) =>
        a.first_name.localeCompare(b.first_name)
      )
    );
    setIncludedChecked(new Set());
    setExcludeChecked(new Set());
  };

  const handleIncludeAll = () => {
    setIncludedUsers((prev) =>
      [...prev, ...excludeUsers].sort((a, b) =>
        a.first_name.localeCompare(b.first_name)
      )
    );
    setExcludeUsers([]);
    setIncludedChecked(new Set());
    setExcludeChecked(new Set());
  };
  return (
    <div>
      <div className={classes["tree-body"]}>
        {/* Exclude Folder Panel */}
        <div className={classes["tree-panel"]}>
          <div className={classes["tree-panel-label"]}>Excluded users</div>
          <div className={classes["tree-panel-box"]}>
            <ul className={classes["tree-select"]}>
              {excludeUsers.map((node) => (
                <TreeNode
                  key={node.user_id}
                  node={node}
                  checkedIds={includedChecked}
                  onToggleCheck={handleToggleCheck(setIncludedChecked)}
                />
              ))}
            </ul>
          </div>
        </div>
        {/* Center Transfer Buttons */}
        <div className={classes["tree-center"]}>
          <button
            className={classes["tree-transfer-btn"]}
            disabled={includedChecked.size === 0}
            onClick={handleInclude}
            type="button"
          >
            Include &rarr;
          </button>
          <button
            className={classes["tree-transfer-btn"]}
            disabled={excludeChecked.size === 0}
            onClick={handleExclude}
            type="button"
          >
            &larr; Exclude
          </button>

          <button
            className={classes["tree-transfer-btn"]}
            disabled={excludeUsers.length === 0}
            onClick={handleIncludeAll}
            type="button"
          >
            Include All &rarr;
          </button>

          <button
            className={classes["tree-transfer-btn"]}
            disabled={includedUsers.length === 0}
            onClick={handleExcludeAll}
            type="button"
          >
            &larr; Exclude All
          </button>
        </div>

        {/* Assign User Panel */}
        <div className={classes["tree-panel"]}>
          <div className={classes["tree-panel-label"]}>Assign Users</div>
          <div className={classes["tree-panel-box"]}>
            <ul className={classes["tree-select"]}>
              {includedUsers.map((node) => (
                <TreeNode
                  key={node.user_id}
                  node={node}
                  checkedIds={excludeChecked}
                  onToggleCheck={handleToggleCheck(setExcludeChecked)}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
